import Link from 'next/link';
import { DEFAULT_LOGO_PROPS } from './Logo.constants';
import { LogoProps } from './Logo.interfaces';
import { getValidClassNames } from '@/utils';
import { IImage } from '@netfront/ui-library';
import { ESize } from '@/models/enums';

type InternalLogoProps = {
  as?: 'a' | 'div';
  href?: string;
  image?: IImage;
  label?: string;
  size?: ESize;
};

export const Logo = (logo: LogoProps) => {
  const logoProps: InternalLogoProps = {
    ...DEFAULT_LOGO_PROPS(logo.variant ?? 'primary'),
    ...logo,
  };

  const Component = logoProps.as ?? Link;

  return (
    <Component
      className={getValidClassNames({
        'c-logo': true,
        [`c-logo-${logoProps.size}`]: Boolean(logoProps.size),
        [String(logo.additionalClassNames)]: Boolean(logo.additionalClassNames)
      })}
      href={String(logoProps.href)}
    >
      <span className="sr-only">{logoProps.label}</span>
      <img alt={logoProps.image?.altText} className="c-logo__image" src={logoProps.image?.src} />
    </Component>
  );
};
